export default __webpack_public_path__ + "static/media/life-shared.38e916e8.svg";